var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Dupont Kalrez®",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', {
    staticClass: "mb-lg-42"
  }, [_c('h2', {
    staticClass: "page-tit mb-18 mb-lg-24"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "470",
      "src": "/images/logos/kalrez.png",
      "alt": "Dupont Kalrez"
    }
  })], 1), _c('h3', {
    staticClass: "tit text-center primary--text"
  }, [_vm._v("Dupont Kalrez® Authorized Distributor")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-top-img.png",
      "className": "h-lg-280px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" Kalrez® specialty sealing "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" engineered for your "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" mission-critical applications. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v("Kalrez® parts serve a variety of industries, from aerospace and chemical processing to chip manufacturing, oil and gas extraction, and more. More effective, suitable for stability and resistance to harsh conditions in various fields We manufacture products to be sealed.")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Features"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" Kalrez® components with a variety of compounds can withstand different chemicals and temperatures. It has durable properties and is excellent in chemical resistance. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon2.png",
      "iconWidth": "38",
      "num": "02"
    }
  }, [_vm._v("It has strong heat resistance and can replace metals, ceramics, and other polymers. This product is optimized for cost reduction and application in a variety of uses.")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" Kalrez® products are certified products that reduce the possibility of seal failure. Meets stringent requirements for rapid gas decompression ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" Since purity is critical to wafer yield, the specially designed Kalrez® FFKM seal Reduce wafer contamination from particles, outgassing and extractables ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez®"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v("Kalrez® parts are manufactured by Dupont Elastomers consistently from raw material polymer to rubber molding. It is a registered trademark of Perfluoro Elastomer parts and is a product made of rubberized Teflon. It is a highly functional rubber material that is highly resistant even in harsh environments. It is used in all industrial fields that require precision and high performance.")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Plasma Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9600")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· A product with excellent resistance to Fluorine and Oxygen plasma environments")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Compression set characteristics have been improved on the strengths of Kalrez® 9500 and are specialized for CVD/ALD processes.")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9500")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product with excellent heat resistance to high temperatures")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Sticking and outgassing areas improved")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9300")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product with balanced resistance to physical and chemical plasma")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Minimize generation of metal particles")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9100")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product that minimizes particle generation and erosion caused by plasma")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Excellent resistance to dry processes")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 6005")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Products specialized for etching, ashing, stripping processes, etc.")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Has low sticking characteristics at high temperatures")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8002")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product that minimizes particle generation due to oxygen and fluorine-based plasma")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Has low permanent compression set")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8085")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· A product that minimizes particle generation in an NF3 plasma environment")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Designed to have high mechanical strength")])])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Thermal Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8900")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product with excellent heat resistance to high temperatures")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Sticking and outgassing areas improved")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 7075")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Products that maintain mechanical properties at high temperatures")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Has low permanent compression set rate")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8475")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product that lowers seal temperature rise by reducing infrared absorption")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Specialized in Lamp Anneal, RTP Sealing, etc.")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8575")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Product with improved elastic recovery and improved outgassing")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Improved resistance to chlorine-based cleaning gases such as CIF3")])])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table--last client-table-lg w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Wet Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 6375")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Used in all wet chemical processes")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 4079")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Universally used in dry and wet processes")])])])])])])])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® material properties"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® Grade")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Color")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Image")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Hardness")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Max Service Temp. ℃(℉)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Compression Set at 70hr204℃, %")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9600")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("When exposed to fluorine and oxygen plasma radicals in high temperature vacuum environments, the sealing exhibits extremely low erosion rates and weight loss due to plasma attack and provides excellent chemical resistance to ammonia, ozone and water vapor.​")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Olive- Green")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#89AC23",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9600.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("315 (599)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("15")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9500")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("SACVD, FCVD, PECVD processes Suitable for deposition processes that generate ozone, ammonia, and water vapor")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Tan")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FABA86",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9500.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("310 (590)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("20")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9300")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Used for dielectric etch and has excellent resistance to oxygen- and fluorine-based plasma and chemicals.")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Brown")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#800000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9300.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("25")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9100")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Suitable for ALD, HDPCVD, Conductor EtchLow elution and ultra-low particle generation in plasma environments")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Amber")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FFCC00",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9100.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("18")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8002")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("It is a transparent product for use in the Ash/Strip process and has excellent crack resistance and produces ultra-low fine particles in oxygen- and fluorine-based plasma compared to products containing inorganic additives.​")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Clear")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#D9D9D9",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8002.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("69")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("275 (527)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("12")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8705")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Demonstrates chemical resistance to high concentrations of harmful oxygen free radicals caused by high-energy ultraviolet rays emitted from plasma and excellent sealing function even in high-temperature vacuum.​")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8705.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("327 (621)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("24")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8900")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("It maintains excellent physical properties at high temperatures such as oxidation, ALD, and LPCVD, and has excellent strength, making it suitable for both static and dynamic sealing applications.​")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8900.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("325 (617)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("20")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8575")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Exhibits very low IR (infrared) absorption and outgassing characteristics at high temperatures such as oxidation, lamp annealing, and RTP.")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("White")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8 border border-2",
    attrs: {
      "color": "#fff",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8575.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("63")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("25")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("7075 UP")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Excellent thermal stability (327℃), such as metal and CVD, products made with Kalrez® 7075 UP can be post-processed in ultrapure water")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-7075-up.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("75")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("327 (621)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("13")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9500")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("High thermal stability, very low emissions and excellent rigidity, making it suitable for both static and dynamic sealing applications")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Tan")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FABA86",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9500.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("310 (590)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("18")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9600")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Excellent compression elasticity under high temperature conditions and excellent low outgassing properties in ultra-low vacuum, making it suitable for applications where purity is very important.")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Olive- Green")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#89AC23",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9600-2.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("315 (599)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("12")])])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    staticClass: "mb-40 mb-lg-60",
    attrs: {
      "tit": "Kalrez® Recommended materials for each process"
    }
  }, [_c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Plasma Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end w-md-26"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("HDPCVD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("High-Density Plasma "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("High-density plasma chemical vapor deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("Applying TMS to the wafer surface for dissolving and removing organic residues")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("DEMS, TEOS, SiH₄, SiF₄, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("NH₃, O₂, N₂O, C₄F₈, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9100 / 9500")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("PECVD / PEALD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Plasma-Enhanced "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Atomic Layer Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Plasma-enhanced atomic layer deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("275℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("310℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("Use of TMS, DEMS, TEOS")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("SiH₄, SiF₄, NH₃, O₂, N₂O, C₄F₈, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9600")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" PECVD"), _c('br'), _vm._v(" Curing Process ")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Plasma-Enhanced "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Coating and curing process using plasma-enhanced chemical vapor deposition technology")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("150℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("200℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("O₃ + UV Light")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 8705 / 9500")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("SACVD / FCVD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Sub-Atmospheric Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Layer deposition technology using chemical vapor deposition technology in a partial vacuum environment")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("280℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("TEP")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("NH₃, O₃, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9500 / 9600")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Conductor Etch")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Poly / Metal")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Technology for removing the conductive layer")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("150℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("225℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, CHF₃, HBr, BCl₃, CCl₄, Cl₂, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9100 / 9300")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Dielectric Etch")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Oxide")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Technology to remove insulating layers such as oxides")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("100℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("180℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, C₃F₈, CHF₃, SF₆, O₂, H₂")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9300")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Ash / Strip")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Process to remove organic matter from the surface of the ash layer / Strip process is a process to remove oxides")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("180℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("250℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, CHF₃, O₂, NH₃, Water Vapor, H₂, Forming Gas")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9300 / 8002")])])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Thermal Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end w-md-26"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" ALD, LPCVD, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Metal CVD ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', [_c('div', [_vm._v("ALD")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("Atomic Layer Deposition")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("LPCVD")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("Low Pressure Chemical Vapor Deposition")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Metal CVD")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("Metal Chemical Vapor Deposition")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" WF₆, TiCl₄, HF, SiF₄, F₂, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" N₂O Vapor, Cl₂, ClF₃ ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 7075 UP / 8900")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Oxidation, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Nitridation, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Diffusion ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', [_c('div', [_vm._v("Oxidation")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("The loss of electrons during a reaction by a molecule, atom or ion")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Niridation")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("Heat treating process that diffuses nitrogen into the surface of a metal to create a case-hardened surface")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Diffusion")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("The process of moving impurities from the surface to the inside of a semiconductor device")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" O₂, N₂, N₂O Vapor, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Cl₂, O₃, HCl ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 7075 UP / 8900")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Lamp Anneal, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" RTP ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_vm._v("The crystallinity of the material structure increases due to high temperature heating by exposure to light and is maintained above 1000℃, improving the characteristics of semiconductor devices.")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("275℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" Infrared Light, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" N₂O Vapor, O₂ ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 8575")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Wafer Surface "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Preparation ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_vm._v("Makes the semiconductor wafer surface clean and smoothProcess to enable application to the next process")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("275℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("NH₃, H₂, F₂, NF₃, HF")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9500 / 9600")])])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Wet Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Wafer Preparation")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("UPW")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Ultra-Pure Water)")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Piranha")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("SC-1, SC-2, O₃")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("EKC fluids")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Electronic Grade Chemicals)")])])])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100 font-weight-bold"
  }, [_vm._v("Kalrez® W240UP")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_vm._v("This O-ring is used in filters, valves, pumps, etc. that require chemical resistance and is black in color.")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_vm._v("Resistant to acids and alkalis, preferred as a product for high wetness processes.")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_vm._v("After manufacturing, there are almost no particles in the product through an ultrapure water cleaning process.")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Etching")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("95℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_vm._v("HNO₃, HF₂, H₂O, H₃PO₄, NH₄OH")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Stripping")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("NMP")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(N-Methyl-2-Pyrrolidone)")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Alkanolamine")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Hydroxylamine")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Acetone / IPA")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("EKC 265")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Electronic Grade Chemicals)")])])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Copper Plating")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("CuSO₄ Solution, H₂SO₄")])])])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® Groove"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v("If problems arise when developing new equipment or changing from Viton O-rings to Kalrez® O-rings, the O-ring groove is one of the items to be reviewed. Kalrez® has higher thermal expansion characteristics than Viton, so if used at high temperatures without considering this and changing the groove, cracks or extrusion may occur.")]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Rectangular Groove for Static Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Width(G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth(H)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Radius(R)")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-rectangular.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("102 ~ 178")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.62± "), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.08")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.00")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.55")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.00")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201 ~ 284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.60")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.80")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.60")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("309 ~ 395")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.50")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.90")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("7.15")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.90")])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Dovetail Groove for Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width to Sharps (G`)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width (G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth (H)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Radius (R1)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Bottom Radius (R1)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Side Wall Angle")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-dovetail.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.98")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.75")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.47")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.90")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.77")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])])])]), _c('p', {
    staticClass: "font-size-12 font-size-md-14 mt-8 mt-lg-10 mb-40 mb-lg-60"
  }, [_vm._v("*Although it is a dynamic part with a dovetail design, when applied to process conditions above 250℃, the lifespan may be shorter than that of a static product.")]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Half-Dovetail Groove for Static Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width to Sharps (G`)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width (G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth (H)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Radius (R1)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Bottom Radius (R1)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Side Wall Angle")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-half-dovetail.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.79")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.90")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("24°")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.19")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.49")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.60")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.09")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® Standard"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-14 mb-lg-16"
  }, [_vm._v("Kalrez® parts has O-Rings in stock that comply with AS-568, Metric, JIS, and NW standards, and has the stocks necessary for various industries such as semiconductor and display processes, enabling rapid response to customer requests.")]), _c('div', {
    staticClass: "page-text font-weight-medium mb-40 mb-lg-60"
  }, [_vm._v("You can download the Kalrez® List of standard specifications and check the list by standard.")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "href": "/assets/document/IST_Dupont Kalrez List-Up.pdf",
      "download": ""
    }
  }, [_vm._v("Download Standard Specifications Kalrez® List")])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "M. S. Hwang",
      "tel": "+82-31-765-2268",
      "mail": "mshwang@ist-co.kr",
      "fax": "+82-31-765-2389",
      "link": "https://www.dupont.com/kalrez.html",
      "linkBg": "/images/sub/distributor/dupont/dupont-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }